// API del módulo Auth

import { apiRequest, ApiResponse } from '@/lib/api';
import { 
  SolicitarOtpRequest, 
  SolicitarOtpResponse,
  VerificarOtpRequest,
  VerificarOtpResponse,
  RefreshTokenResponse,
  MeResponse
} from './types';

export const authApi = {
  /**
   * Solicitar código OTP por email o WhatsApp
   */
  solicitarOtp: (data: SolicitarOtpRequest): Promise<ApiResponse<SolicitarOtpResponse>> => {
    return apiRequest<SolicitarOtpResponse>('/api/auth/solicitar-otp', { 
      method: 'POST', 
      body: data 
    });
  },
  
  /**
   * Verificar código OTP y obtener tokens
   */
  verificarOtp: (data: VerificarOtpRequest): Promise<ApiResponse<VerificarOtpResponse>> => {
    return apiRequest<VerificarOtpResponse>('/api/auth/verificar-otp', { 
      method: 'POST', 
      body: data 
    });
  },
  
  /**
   * Renovar access token usando refresh token
   */
  refreshToken: (refreshToken: string): Promise<ApiResponse<RefreshTokenResponse>> => {
    return apiRequest<RefreshTokenResponse>('/api/auth/refresh-token', { 
      method: 'POST', 
      body: { refreshToken } 
    });
  },
  
  /**
   * Cerrar sesión
   */
  logout: (token: string): Promise<ApiResponse<{ success: boolean }>> => {
    return apiRequest<{ success: boolean }>('/api/auth/logout', { 
      method: 'POST', 
      token 
    });
  },
  
  /**
   * Obtener datos del usuario actual
   */
  me: (token: string): Promise<ApiResponse<MeResponse>> => {
    return apiRequest<MeResponse>('/api/auth/me', { token });
  }
};
